import { InitialState } from "./types"
import { INVENTORY_COST_METHOD } from "../models"
import { ACTION_TYPES, Actions } from "../actions/types"
import { stateHandler } from "./handler"

const INITIAL_STATE: InitialState = {
    isFetching: false,
    isLoaded: false,

    id: "",
    enabled: false,
    costMethod: INVENTORY_COST_METHOD.FIFO
}
export const reducer = (state = INITIAL_STATE, action: Actions) => {
    const handler = stateHandler(state)

    switch (action.type) {
    case ACTION_TYPES.FETCH:
        return handler.fetch()
    case ACTION_TYPES.FETCH_SUCCESS:
        return handler.fetchSuccess(action.payload)
    case ACTION_TYPES.UPDATE:
        return handler.update(action.payload)
    default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/configuration/reducers/reducer.ts